export class OptionsDependencyBehaviour {
  constructor(config, dependency) {
    this.type = 'options'
    this.dependency = dependency
    this.config = config
  }

  getOptions() {
    return this.config.from[this._valueFromTrackingField()]
  }

  _valueFromTrackingField() {
    const input = this.dependency.trackingFieldInput
    return input ? input.value : null
  }
}
